<div class="eec-root">

  <!-- Header: Completion summary or Early Exit banner -->
  <ng-container *ngIf="isCompletion; else earlyExitBanner">
    <div class="eec-completion-header" [ngClass]="'eec-completion--' + severity()">
      <div class="eec-completion-icon" [ngClass]="'eec-icon-bg--' + severity()">
        <svg *ngIf="severity() === 'ok'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="20 6 9 17 4 12" />
        </svg>
        <svg *ngIf="severity() === 'warning'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
          <line x1="12" y1="9" x2="12" y2="13" /><line x1="12" y1="17" x2="12.01" y2="17" />
        </svg>
        <svg *ngIf="severity() === 'critical'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="12" /><line x1="12" y1="16" x2="12.01" y2="16" />
        </svg>
      </div>
      <div class="eec-completion-body">
        <div class="eec-completion-label" [ngClass]="'eec-label--' + severity()">Diagnóstico</div>
        <h2 class="eec-completion-headline">{{ completionHeadline() }}</h2>
        <ul *ngIf="findings.length" class="eec-findings">
          <li *ngFor="let f of findings" class="eec-finding">
            <span class="eec-finding__dot" [style.background]="findingDotColor(f.severity)"></span>
            <span>{{ f.text }}</span>
          </li>
        </ul>
        <div class="eec-completion-meta">
          <span><strong>Campaign:</strong> <code>{{ data?.campaign_id }}</code></span>
          <span><strong>Country:</strong> <code>{{ data?.country }}</code></span>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-template #earlyExitBanner>
    <div class="eec-exit-banner">
      <div class="eec-exit-icon">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
          <line x1="12" y1="9" x2="12" y2="13" /><line x1="12" y1="17" x2="12.01" y2="17" />
        </svg>
      </div>
      <div class="eec-exit-body">
        <div class="eec-exit-label">
          Salida anticipada
          <span class="eec-chip eec-chip--amber">{{ stepTitles[data?.exit_step] || ('Paso ' + data?.exit_step) }}</span>
        </div>
        <h2 class="eec-exit-reason">{{ data?.exit_reason || 'La campaña no pudo completar el diagnóstico.' }}</h2>
        <div class="eec-exit-meta">
          <span><strong>Campaign:</strong> <code>{{ data?.campaign_id }}</code></span>
          <span><strong>Country:</strong> <code>{{ data?.country }}</code></span>
        </div>
      </div>
    </div>
  </ng-template>

  <!-- Step cards -->
  <div *ngIf="stepEntries.length" class="eec-steps">
    <section *ngFor="let entry of stepEntries" class="eec-step-card">
      <button type="button" class="eec-step-header" (click)="toggleStep(entry.key)" [attr.aria-expanded]="openSteps[entry.key]">
        <div class="eec-step-icon" [ngClass]="stepAccentClass(stepConfigFor(entry.key).accent)">
          <ng-container [ngSwitch]="entry.key">
            <svg *ngSwitchCase="'step0'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="M9 12l2 2 4-4"/></svg>
            <svg *ngSwitchCase="'step1'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>
            <svg *ngSwitchCase="'step2'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="9" y1="15" x2="15" y2="15"/><line x1="9" y1="11" x2="15" y2="11"/></svg>
            <svg *ngSwitchCase="'step3'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/></svg>
            <svg *ngSwitchCase="'step4'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.59 13.41 13.42 20.58a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/></svg>
            <svg *ngSwitchCase="'step5'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/></svg>
            <svg *ngSwitchCase="'step6'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 3v18h18"/><path d="M7 14l4-4 4 4 5-5"/></svg>
            <svg *ngSwitchDefault viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 18h6"/><path d="M10 22h4"/><path d="M12 2a7 7 0 0 0-4 12.74V17a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-2.26A7 7 0 0 0 12 2z"/></svg>
          </ng-container>
        </div>
        <div class="eec-step-meta">
          <div *ngIf="!stepConfigFor(entry.key).hideStepNumber" class="eec-step-number-row">
            <span class="eec-step-number">Paso {{ stepNumber(entry.key) }}</span>
            <span *ngIf="entry.exitedHere" class="eec-chip eec-chip--amber">Detuvo aquí</span>
          </div>
          <h3 class="eec-step-title">{{ stepConfigFor(entry.key).title }}</h3>
          <p *ngIf="stepConfigFor(entry.key).subtitle" class="eec-step-subtitle">{{ stepConfigFor(entry.key).subtitle }}</p>
        </div>
        <svg class="eec-chevron" [class.eec-chevron--open]="openSteps[entry.key]" viewBox="0 0 20 20" fill="currentColor">
          <path fill-rule="evenodd" d="M5.23 7.21a.75.75 0 0 1 1.06.02L10 11.06l3.71-3.83a.75.75 0 0 1 1.08 1.04l-4.25 4.39a.75.75 0 0 1-1.08 0L5.21 8.27a.75.75 0 0 1 .02-1.06z" clip-rule="evenodd" />
        </svg>
      </button>

      <div *ngIf="openSteps[entry.key]" class="eec-step-body">

        <!-- STEP 0 -->
        <ng-container *ngIf="entry.key === 'step0'">
          <dl class="eec-kv-grid">
            <div class="eec-kv-item">
              <dt>Status</dt>
              <dd>
                <span class="eec-chip" [ngClass]="'eec-chip--' + step0StatusTone(entry.data)">
                  {{ entry.data?.campaign_status || 'desconocido' }}
                </span>
              </dd>
            </div>
            <div class="eec-kv-item"><dt>Inicio</dt><dd>{{ entry.data?.start_date }}</dd></div>
            <div class="eec-kv-item"><dt>Fin</dt><dd>{{ entry.data?.end_date }}</dd></div>
          </dl>
        </ng-container>

        <!-- STEP 1 -->
        <ng-container *ngIf="entry.key === 'step1'">
          <ng-container *ngFor="let budgetPct of [step1BudgetPct(entry.data)]">
            <div class="eec-budget-section">
              <div class="eec-budget-header">
                <span>Gasto sobre budget</span>
                <span class="eec-budget-pct">{{ budgetPct.toFixed(1) }}%</span>
              </div>
              <div class="eec-progress-track">
                <div class="eec-progress-bar" [style.width.%]="budgetPct" [style.background]="step1BarColor(budgetPct)"></div>
              </div>
            </div>
          </ng-container>
          <div class="eec-stat-grid eec-stat-grid--4">
            <div class="eec-stat"><div class="eec-stat__label">Budget</div><div class="eec-stat__value">{{ formatMoney(entry.data?.budget) }}</div></div>
            <div class="eec-stat"><div class="eec-stat__label">Spend (data)</div><div class="eec-stat__value">{{ formatMoney(entry.data?.spend_data) }}</div></div>
            <div class="eec-stat"><div class="eec-stat__label">Spend (ad server)</div><div class="eec-stat__value">{{ formatMoney(entry.data?.spend_ad_server) }}</div></div>
            <div class="eec-stat" [ngClass]="entry.data?.remaining_budget <= 0 ? 'eec-stat--danger' : 'eec-stat--success'">
              <div class="eec-stat__label">Remaining</div>
              <div class="eec-stat__value">{{ formatMoney(entry.data?.remaining_budget) }}</div>
            </div>
          </div>
        </ng-container>

        <!-- STEP 2 -->
        <ng-container *ngIf="entry.key === 'step2'">
          <div class="eec-stat-grid eec-stat-grid--2">
            <div class="eec-stat" [ngClass]="entry.data?.ads_written ? 'eec-stat--success' : 'eec-stat--danger'">
              <div class="eec-stat__label">Ads escritos hoy</div>
              <div class="eec-stat__value">{{ entry.data?.ads_written ? 'Sí' : 'No' }}</div>
            </div>
            <div class="eec-stat">
              <div class="eec-stat__label">Filas en defrag</div>
              <div class="eec-stat__value">{{ formatNumber(entry.data?.total_rows) }}</div>
            </div>
          </div>
        </ng-container>

        <!-- STEP 3 -->
        <ng-container *ngIf="entry.key === 'step3'">
          <div class="eec-stat-grid eec-stat-grid--1" style="margin-bottom: 16px">
            <div class="eec-stat"><div class="eec-stat__label">Total combinaciones</div><div class="eec-stat__value">{{ formatNumber(entry.data?.total_combinations) }}</div></div>
          </div>
          <div *ngIf="entry.data?.rows?.length" class="eec-data-table-wrap">
            <div class="eec-scroll">
              <table class="eec-table">
                <thead><tr><th *ngFor="let col of tableColumns(entry.data.rows)" class="eec-th">{{ labelFor(col) }}</th></tr></thead>
                <tbody>
                  <tr *ngFor="let row of entry.data.rows">
                    <td *ngFor="let col of tableColumns(entry.data.rows)" class="eec-td">{{ formatValue(col, row[col]) }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </ng-container>

        <!-- STEP 4 -->
        <ng-container *ngIf="entry.key === 'step4'">
          <div *ngIf="entry.data?.search_keyword" class="eec-keyword-summary" [ngClass]="(entry.data?.categories_with_match > 0) ? 'eec-keyword-summary--match' : 'eec-keyword-summary--no-match'">
            <p>
              <span *ngIf="entry.data?.categories_with_match > 0">
                <code>{{ entry.data.search_keyword }}</code> aparece en
                <strong>{{ entry.data.categories_with_match }}</strong> de
                <strong>{{ entry.data.total_categories }}</strong> categorías.
              </span>
              <span *ngIf="!entry.data?.categories_with_match">
                <code>{{ entry.data.search_keyword }}</code> no aparece en las keywords de ninguna de las
                <strong>{{ entry.data.total_categories }}</strong> categorías.
              </span>
            </p>
          </div>
          <div *ngFor="let row of entry.data?.rows" class="eec-kw-category" [ngClass]="row.has_match ? 'eec-kw-category--match' : ''">
            <div class="eec-kw-category__header">
              <div>
                <code class="eec-muted">#{{ row.categorie_id }}</code>
                <strong class="eec-kw-category__name">{{ row.category_name || 'Sin nombre' }}</strong>
              </div>
              <div class="eec-kw-category__meta">
                <span *ngIf="row.has_match" class="eec-chip eec-chip--emerald">{{ row.matches_in_cloud }} match{{ row.matches_in_cloud === 1 ? '' : 'es' }}</span>
                <span *ngIf="entry.data?.search_keyword && !row.has_match" class="eec-chip eec-chip--slate">Sin match</span>
                <span class="eec-muted">{{ row.keywords?.length }} keywords</span>
              </div>
            </div>
            <div class="eec-kw-list">
              <span *ngFor="let kw of row.keywords" class="eec-kw-tag" [ngClass]="row.matched_keywords?.includes(kw) ? 'eec-kw-tag--match' : ''">{{ kw }}</span>
              <span *ngIf="!row.keywords?.length" class="eec-muted">Sin keywords</span>
            </div>
          </div>
        </ng-container>

        <!-- STEP 5 -->
        <ng-container *ngIf="entry.key === 'step5'">
          <div class="eec-stat-grid eec-stat-grid--3" style="margin-bottom: 16px">
            <div class="eec-stat"><div class="eec-stat__label">Total productos</div><div class="eec-stat__value">{{ formatNumber(entry.data?.total_products) }}</div></div>
            <div class="eec-stat eec-stat--success"><div class="eec-stat__label">Con stock</div><div class="eec-stat__value">{{ formatNumber(entry.data?.products_with_stock) }}</div></div>
            <div class="eec-stat" [ngClass]="entry.data?.products_without_stock?.length > 0 ? 'eec-stat--danger' : ''">
              <div class="eec-stat__label">Sin stock</div>
              <div class="eec-stat__value">{{ formatNumber(entry.data?.products_without_stock?.length) }}</div>
            </div>
          </div>
          <div *ngIf="entry.data?.products_without_stock?.length" class="eec-no-stock-box">
            <div class="eec-no-stock-box__label">Productos sin stock</div>
            <div class="eec-no-stock-box__list">
              <code *ngFor="let pid of entry.data.products_without_stock" class="eec-no-stock-box__tag">{{ pid }}</code>
            </div>
          </div>
          <div *ngIf="entry.data?.url_store_id && entry.data?.rows?.length" class="eec-store-match-hint" [ngClass]="step5HasMatch(entry.data) ? 'eec-store-match-hint--match' : 'eec-store-match-hint--no-match'">
            <span class="eec-store-match-hint__dot" [style.background]="step5HasMatch(entry.data) ? '#10b981' : '#f59e0b'"></span>
            <span *ngIf="step5HasMatch(entry.data)">La tienda del URL (<code>{{ entry.data.url_store_id }}</code>) aparece entre las tiendas con stock.</span>
            <span *ngIf="!step5HasMatch(entry.data)">La tienda del URL (<code>{{ entry.data.url_store_id }}</code>) no aparece entre las tiendas con stock.</span>
          </div>
          <div *ngIf="entry.data?.rows?.length">
            <button type="button" class="eec-toggle-btn" (click)="toggleStores(entry.key)">
              <span>Tiendas con stock ({{ entry.data.rows.length }})</span>
              <svg class="eec-chevron-sm" [class.eec-chevron--open]="showStoresMap[entry.key]" viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M5.23 7.21a.75.75 0 0 1 1.06.02L10 11.06l3.71-3.83a.75.75 0 0 1 1.08 1.04l-4.25 4.39a.75.75 0 0 1-1.08 0L5.21 8.27a.75.75 0 0 1 .02-1.06z" clip-rule="evenodd"/></svg>
            </button>
            <div *ngIf="showStoresMap[entry.key]" class="eec-scroll eec-data-table-wrap">
              <table class="eec-table">
                <thead>
                  <tr>
                    <th class="eec-th">#</th><th class="eec-th">Tu tienda</th><th class="eec-th">Store ID</th>
                    <th class="eec-th">Super Store ID</th><th class="eec-th">Store type</th>
                    <th class="eec-th eec-th--right">Productos</th><th class="eec-th">Tienda</th><th class="eec-th">Dirección</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let row of entry.data.rows" [ngClass]="String(row.store_id) === String(entry.data.url_store_id) ? 'eec-tr--match' : ''">
                    <td class="eec-td">{{ row.store_rank }}</td>
                    <td class="eec-td">
                      <span *ngIf="String(row.store_id) === String(entry.data.url_store_id)" class="eec-chip eec-chip--emerald">✓ Match</span>
                      <span *ngIf="String(row.store_id) !== String(entry.data.url_store_id)" class="eec-muted">·</span>
                    </td>
                    <td class="eec-td eec-td--mono">{{ safe(row.store_id) }}</td>
                    <td class="eec-td eec-td--mono">{{ safe(row.super_store_id) }}</td>
                    <td class="eec-td">{{ safe(row.store_type) }}</td>
                    <td class="eec-td eec-td--right">{{ safe(row.products_in_store) }}</td>
                    <td class="eec-td">{{ safe(row.store_name) }}</td>
                    <td class="eec-td eec-td--muted">{{ safe(row.store_address) }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </ng-container>

        <!-- STEP 6 -->
        <ng-container *ngIf="entry.key === 'step6'">
          <div class="eec-impressions-hero">
            <svg class="eec-donut" width="144" height="144" viewBox="0 0 144 144">
              <circle cx="72" cy="72" [attr.r]="donutRadius(144)" fill="none" stroke="#e2e8f0" stroke-width="14" />
              <circle cx="72" cy="72" [attr.r]="donutRadius(144)" fill="none"
                [attr.stroke]="donutColor(entry.data?.overall_fill_rate)"
                stroke-width="14"
                [attr.stroke-dasharray]="donutCircumference(144)"
                [attr.stroke-dashoffset]="donutOffset(entry.data?.overall_fill_rate, 144)"
                stroke-linecap="round"
                transform="rotate(-90 72 72)" />
              <text x="72" y="72" text-anchor="middle" dominant-baseline="central" style="font-size:22px;font-weight:600;" fill="#0f172a">
                {{ donutDisplay(entry.data?.overall_fill_rate) }}
              </text>
            </svg>
            <div class="eec-impressions-hero__body">
              <div class="eec-impressions-hero__status">
                <span class="eec-badge eec-badge--dot" [ngClass]="fillStatusClass(step6OverallStatus(entry.data))">
                  <span class="eec-dot" [style.background]="fillStatusDot(step6OverallStatus(entry.data))"></span>
                  {{ statusLabels[step6OverallStatus(entry.data)] }}
                </span>
                <span class="eec-impressions-hero__headline">{{ step6Headline(entry.data) }}</span>
              </div>
              <p class="eec-impressions-hero__desc">
                <strong>{{ formatNumber(entry.data?.total_renders_delivered) }}</strong> de
                <strong>{{ formatNumber(entry.data?.total_renders_planned) }}</strong> renders entregados en
                <strong>{{ formatNumber(entry.data?.total_pairs) }}</strong> combinaciones.
              </p>
              <div class="eec-stat-grid eec-stat-grid--3" style="margin-top:12px">
                <div class="eec-stat"><div class="eec-stat__label">Planificados</div><div class="eec-stat__value">{{ formatNumber(entry.data?.total_renders_planned) }}</div></div>
                <div class="eec-stat"><div class="eec-stat__label">Entregados</div><div class="eec-stat__value">{{ formatNumber(entry.data?.total_renders_delivered) }}</div></div>
                <div class="eec-stat"><div class="eec-stat__label">Combinaciones</div><div class="eec-stat__value">{{ formatNumber(entry.data?.total_pairs) }}</div></div>
              </div>
            </div>
          </div>
          <div *ngIf="step6NoDeliveryCount(entry.data) > 0" class="eec-no-delivery-alert">
            <strong>{{ step6NoDeliveryCount(entry.data) }}</strong> combinación{{ step6NoDeliveryCount(entry.data) === 1 ? '' : 'es' }} sin impresiones entregadas.
          </div>
          <div *ngIf="step6SortedSummary(entry.data)?.length" class="eec-section-header">
            <span>Por placement / store type</span>
            <span class="eec-muted">{{ step6SortedSummary(entry.data).length }} combinaciones</span>
          </div>
          <div *ngIf="step6SortedSummary(entry.data)?.length" class="eec-scroll eec-data-table-wrap">
            <table class="eec-table">
              <thead>
                <tr>
                  <th class="eec-th">Placement</th><th class="eec-th">Store type</th>
                  <th class="eec-th eec-th--right">Ad slots</th><th class="eec-th eec-th--right">Planificados</th>
                  <th class="eec-th eec-th--right">Entregados</th><th class="eec-th">Fill rate</th><th class="eec-th">Estado</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let row of step6SortedSummary(entry.data)" [ngClass]="row.fill_status === 'no_delivery' ? 'eec-tr--red' : row.fill_status === 'exhausted' ? 'eec-tr--amber' : ''">
                  <td class="eec-td eec-td--bold">{{ row.placement }}</td><td class="eec-td">{{ row.store_type }}</td>
                  <td class="eec-td eec-td--right">{{ row.ad_slots }}</td>
                  <td class="eec-td eec-td--right">{{ formatNumber(row.renders_planned) }}</td>
                  <td class="eec-td eec-td--right">{{ formatNumber(row.renders_delivered) }}</td>
                  <td class="eec-td">
                    <div class="eec-fill-bar">
                      <div class="eec-fill-bar__track"><div class="eec-fill-bar__fill" [style.width.%]="fillRatePct(row.fill_rate)" [style.background]="fillRateBarColor(row.fill_rate)"></div></div>
                      <span class="eec-fill-bar__label">{{ formatFillRate(row.fill_rate) }}</span>
                    </div>
                  </td>
                  <td class="eec-td">
                    <span class="eec-badge eec-badge--dot" [ngClass]="fillStatusClass(row.fill_status)">
                      <span class="eec-dot" [style.background]="fillStatusDot(row.fill_status)"></span>
                      {{ statusLabels[row.fill_status] }}
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div *ngIf="entry.data?.rows?.length">
            <button type="button" class="eec-toggle-btn" (click)="toggleDetails(entry.key)">
              <span>Detalle por ad slot / categoría ({{ entry.data.rows.length }})</span>
              <svg class="eec-chevron-sm" [class.eec-chevron--open]="showDetailsMap[entry.key]" viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M5.23 7.21a.75.75 0 0 1 1.06.02L10 11.06l3.71-3.83a.75.75 0 0 1 1.08 1.04l-4.25 4.39a.75.75 0 0 1-1.08 0L5.21 8.27a.75.75 0 0 1 .02-1.06z" clip-rule="evenodd"/></svg>
            </button>
            <div *ngIf="showDetailsMap[entry.key]" class="eec-scroll eec-data-table-wrap">
              <table class="eec-table">
                <thead>
                  <tr>
                    <th class="eec-th">Placement</th><th class="eec-th">Store type</th><th class="eec-th eec-th--right">Ad slot</th>
                    <th class="eec-th">Categoría</th><th class="eec-th eec-th--right">Planificados</th><th class="eec-th eec-th--right">Entregados</th>
                    <th class="eec-th">Fill rate</th><th class="eec-th">Estado</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let row of entry.data.rows" [ngClass]="row.fill_status === 'no_delivery' ? 'eec-tr--red' : row.fill_status === 'exhausted' ? 'eec-tr--amber' : ''">
                    <td class="eec-td eec-td--bold">{{ row.placement }}</td><td class="eec-td">{{ row.store_type }}</td>
                    <td class="eec-td eec-td--right">{{ row.ad_slot }}</td><td class="eec-td eec-td--mono">{{ safe(row.categorie_id) }}</td>
                    <td class="eec-td eec-td--right">{{ formatNumber(row.renders_planned) }}</td>
                    <td class="eec-td eec-td--right">{{ formatNumber(row.renders_delivered) }}</td>
                    <td class="eec-td">
                      <div class="eec-fill-bar">
                        <div class="eec-fill-bar__track"><div class="eec-fill-bar__fill" [style.width.%]="fillRatePct(row.fill_rate)" [style.background]="fillRateBarColor(row.fill_rate)"></div></div>
                        <span class="eec-fill-bar__label">{{ formatFillRate(row.fill_rate) }}</span>
                      </div>
                    </td>
                    <td class="eec-td">
                      <span class="eec-badge eec-badge--dot" [ngClass]="fillStatusClass(row.fill_status)">
                        <span class="eec-dot" [style.background]="fillStatusDot(row.fill_status)"></span>
                        {{ statusLabels[row.fill_status] }}
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </ng-container>

        <!-- STEP 7 -->
        <ng-container *ngIf="entry.key === 'step7'">
          <div *ngIf="!entry.data?.rows?.length" class="eec-empty-box">
            <p>La campaña <strong>no está entregando</strong> en otros store types hoy.</p>
            <p *ngIf="entry.data?.excluded_store_type" class="eec-muted">(Se excluyó el store type del URL: <code>{{ entry.data.excluded_store_type }}</code>)</p>
          </div>
          <div *ngIf="entry.data?.rows?.length" class="eec-scroll eec-data-table-wrap">
            <table class="eec-table">
              <thead>
                <tr>
                  <th class="eec-th">Store type</th><th class="eec-th">Placement</th><th class="eec-th">Categoría</th>
                  <th class="eec-th">Keywords sugeridas</th><th class="eec-th eec-th--right">Planificados</th>
                  <th class="eec-th eec-th--right">Entregados</th><th class="eec-th">Fill rate</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let row of entry.data.rows">
                  <td class="eec-td eec-td--mono">{{ safe(row.store_type) }}</td>
                  <td class="eec-td eec-td--bold">{{ safe(row.placement) }}</td>
                  <td class="eec-td">
                    <code class="eec-muted">#{{ safe(row.categorie_id) }}</code>
                    {{ row.category_name || '—' }}
                  </td>
                  <td class="eec-td">
                    <div *ngIf="row.keywords?.length" class="eec-kw-list">
                      <span *ngFor="let kw of row.keywords" class="eec-kw-tag eec-kw-tag--violet">{{ kw }}</span>
                    </div>
                    <span *ngIf="!row.keywords?.length" class="eec-muted">—</span>
                  </td>
                  <td class="eec-td eec-td--right eec-td--bold">{{ formatNumber(row.renders_planned) }}</td>
                  <td class="eec-td eec-td--right">{{ formatNumber(row.renders_delivered) }}</td>
                  <td class="eec-td">
                    <div class="eec-fill-bar">
                      <div class="eec-fill-bar__track"><div class="eec-fill-bar__fill" [style.width.%]="fillRatePct(row.fill_rate)" [style.background]="fillRateBarColor(row.fill_rate)"></div></div>
                      <span class="eec-fill-bar__label">{{ formatFillRate(row.fill_rate) }}</span>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </ng-container>

        <!-- Generic fallback -->
        <ng-container *ngIf="!['step0','step1','step2','step3','step4','step5','step6','step7'].includes(entry.key)">
          <dl class="eec-kv-grid">
            <div *ngFor="let e of primitiveEntries(entry.data)" class="eec-kv-item">
              <dt>{{ labelFor(e[0]) }}</dt><dd>{{ formatValue(e[0], e[1]) }}</dd>
            </div>
          </dl>
          <div *ngFor="let t of tableEntries(entry.data)">
            <div class="eec-section-label">{{ labelFor(t[0]) }} ({{ t[1].length }})</div>
            <div class="eec-scroll eec-data-table-wrap">
              <table class="eec-table">
                <thead><tr><th *ngFor="let col of tableColumns(t[1])" class="eec-th">{{ labelFor(col) }}</th></tr></thead>
                <tbody><tr *ngFor="let row of t[1]"><td *ngFor="let col of tableColumns(t[1])" class="eec-td">{{ formatValue(col, row[col]) }}</td></tr></tbody>
              </table>
            </div>
          </div>
        </ng-container>

      </div>
    </section>
  </div>

  <!-- Other (non-step) entries -->
  <section *ngIf="otherEntries.length" class="eec-step-card">
    <h3 class="eec-other-title">Otros detalles</h3>
    <dl class="eec-other-grid">
      <div *ngFor="let e of otherEntries" class="eec-kv-item">
        <dt>{{ labelFor(e[0]) }}</dt>
        <dd>{{ formatValue(e[0], e[1]) }}</dd>
      </div>
    </dl>
  </section>

</div>
